import {
	ContentCopyRounded,
	EditOutlined,
} from "@mui/icons-material";
import {
	Avatar,
	AvatarGroup,
	Box,
	Chip,
	Grid,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import moment from "moment";
import LoopSharpIcon from "@mui/icons-material/LoopSharp";
import {
	getPersistentList,
	refreshBestDeals,
	refreshMostPopular,
} from "../../apis/PersistentList";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useMemo, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { notify } from "../Playoff/PlayListTable";
import { debounce } from "lodash";
import MUIDataTable from "mui-datatables";

export default function DataTable({
	rows = [],
	handleDelete,
	loading,
	handlePage,
	handleRowsCount,

	setRows,
}) {
	// console.log(page * rowsCount, (page + 1) * rowsCount);
	const [open, setOpen] = useState(false);
	const [activeSelection, setActiveSelection] = useState(null);
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);

	const [searchText, setSearchText] = useState("");

	const [count, setCount] = useState(0);
	const [rowsCount, setRowsCount] = useState(10);

	const handleSearchChange = useMemo(
		() => debounce((searchText) => {
			setSearchText(searchText);
		}, 500),
		[]
	);

	useEffect(() => () => handleSearchChange.cancel(), [handleSearchChange]);

	useEffect(() => {
		getPersistentList(rowsCount, page + 1, searchText).then((res) => {
			setData(res.results);
			setCount(res.count);
		});
	}, [page, rowsCount, searchText]);

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},
		{
			name: "slug",
			label: "Slug",
			options: {
				filter: false,
				sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "title",
			label: "Title",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "list_type",
			label: "List Type",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ style: { width: 150, maxWidth: 150 } }),
				// setCellHeaderProps: () => ({
				// 	style: { width: 120, maxWidth: 150 },
				// }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Typography
							variant="p"
							sx={{
								textTransform: "capitalize",
							}}
						>
							{value.split("_").join(" ")}
						</Typography>
					);
				},
			},
		},
		{
			name: "image",
			label: "Collage",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="List Logo"
							variant="square"
							sx={{
								width: 100,
								height: 100,
								objectFit: "fill",
								borderRadius: 4,
							}}
							src={value?.file}
						/>
					);
				},
			},
		},
		{
			name: "description",
			label: "Description",
			options: {
				filter: false,
				sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Typography
							variant="p"
							sx={{
								textTransform: "capitalize",
							}}
						>
							{value}
						</Typography>
					);
				},
			},
		},

		{
			name: "products",
			label: "Products",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<AvatarGroup
							sx={{
								justifyContent: "center",
							}}
							total={value?.length}
						>
							{value.slice(0, 3).map((p, i) => (
								<Avatar
									key={`prod-${i}`}
									alt={p.name}
									src={p.image.file}
								/>
								//<p>{p.image.file}</p>
							))}
						</AvatarGroup>
					);
				},
			},
		},
		{
			name: "list_category",
			label: "List Category",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return value.map((p, i) => (
						<Typography
							component={"p"}
							variant="p"
							key={`list-${i}`}
						>
							{p.name}
						</Typography>
					));
				},
			},
		},
		{
			name: "Last Update",
			label: "Last Update",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowIndex } = tableMeta;
					const row = data[rowIndex];
					// console.log("yes", value);
					return (
						(row.title === "Community Favourites" ||
							row.title === "Curated Deals") && (
							<Chip
								variant="outlined"
								sx={{ marginY: 2 }}
								label={moment(row.updated_at)
									.utcOffset("+05:30")
									.format("DD-MM-YY hh:mm A")}
								color="error"
							/>
						)
					);
				},
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowIndex } = tableMeta;
					const row = data[rowIndex];
					return (
						<Stack direction={"row"}>
							<CopyToClipboard
								text={`https://www.grape.town/list/${row.slug}`}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
							<IconButton
								color="primary"
								href={`/w86zjruk6q/persistent-list/${row.id}/edit/`}
							>
								<EditOutlined />
							</IconButton>
							{(row.title === "Community Favourites" ||
								row.title === "Curated Deals") && (
									<>
										<Tooltip
											title={
												<Typography
													sx={{
														fontSize: "14px",
													}}
												>{`Refresh ${row.title}`}</Typography>
											}
											arrow
										>
											<Button
												color="primary"
												variant="outlined"
												sx={{
													borderRadius: "50%",
													paddingX: 0,
													width: "40px",
													minWidth: "40px",
													height: "40px",
													marginX: 1,
												}}
												onClick={() => {
													refresh(row);
												}}
											>
												<LoopSharpIcon />
											</Button>
										</Tooltip>
									</>
								)}
						</Stack>
					);
				},
			},
		},
	];

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filter: false,
		// filterType: "multiselect",
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
			setPage(0);
		},
		onSearchChange: handleSearchChange,
		onColumnSortChange: (changedColumn, direction) => {
			// setSortingValues(
			// 	direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
			// );
			// setPage(0)
			// setSortFields(temp);
		},

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	const refresh = (row) => {
		handleClickOpen();
		setActiveSelection(row.title);
	};

	const refreshHandler = async () => {
		let res;
		if (activeSelection === "Community Favourites") {
			res = await refreshMostPopular();
		} else {
			res = await refreshBestDeals();
		}
		if (res.success) {
			const data = await getPersistentList(0);
			setRows(data.results);
			setOpen(false);
		}
	};
	return (
		<Grid container justifyContent="center">
			<Grid item md={12}>
				<MUIDataTable data={data} columns={columns} options={options} />
			</Grid>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Refreshing {activeSelection} will removed all previous
						products and update it with new recent products.
						<br></br>Do you wish to continue?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={refreshHandler} autoFocus>
						Yes
					</Button>
				</DialogActions>
			</Dialog>
		</Grid>
	);
}
